<div>
  <app-lista-dados
    [upTitulo]="'Lista de Regras'"
    [upIcone]="'security'"
    [upCor]="'3F51B5'"
    [upDados]="regras"
    [upColunas]="colunasListaDados"
    [upHabilitaEditarLinha]="true"
    [upLargura]="1"
    [upHabilitaContador]="true"
    [upHabilitaFiltroRapido]="true"
    [upCarregando]="!!subscription"
    (ueBotaoExcluir)="onDelete($event)"
    (ueSalvarLinha)="onSalvarLinha($event)">
  </app-lista-dados>
</div>
